export default "__VITE_ASSET__804372e6__"